import React from 'react';
import icon_info from '../../assets/icon_info.svg';
import './BatterySocLevels.scss';

const SOC_LEVELS = [
  { level: 1, minSoc: 0, maxSoc: 15, label: 'Level 1' },
  { level: 2, minSoc: 15, maxSoc: 30, label: 'Level 2' },
  { level: 3, minSoc: 30, maxSoc: 85, label: 'Level 3' },
  { level: 4, minSoc: 85, maxSoc: 100, label: 'Level 4' },
];

// TODO: Replace with useSocLevels(gxEntityKey) hook when backend ships
const MOCK_TACTICS = [
  { name: 'UPS', minSoc: 0, maxSoc: 100 },
  { name: 'Demand Sustain', minSoc: 15, maxSoc: 100 },
  { name: 'Demand Burst', minSoc: 30, maxSoc: 100 },
  { name: 'PRS', minSoc: 85, maxSoc: 100 },
];

const BatterySocLevels = ({ socPercent, socLevels = SOC_LEVELS, tactics = MOCK_TACTICS }) => {
  const formattedTactics = tactics.map((t) => ({
    ...t,
    name: t.category,
    minSoc: t.allocated === 99 ? 0 : 100 - t.allocated, // Assuming allocated is the same as minSoc for this example
    maxSoc: 100,
  }));
  const activeTactics = formattedTactics.filter((t) => {
    return socPercent >= t.minSoc && socPercent <= t.maxSoc;
  });
  // const currentLevel = socLevels.find((l) => socPercent >= l.minSoc && socPercent <= l.maxSoc);

  const socRow = 1;
  const levelRow = tactics.length + 2;
  const markerEndLine = levelRow + 1;
  // const indicatorsRow = levelRow + 1;

  return (
    <div className="soc-levels-container">
      <div className="soc-levels-heading-row">
        <p className="subhead soc-levels-heading">SOC &amp; Battery Tactics</p>

        <div className="tooltip">
          <img
            src={icon_info}
            alt="More information about SOC and Battery Tactics"
            width="15"
            height="15"
          />
          <div className="tooltip-text">
            <p>
              The SOC &amp; Battery Tactics chart shows the battery&apos;s current State of Charge
              (SOC) and the tactics that use it. Each tactic&apos;s bar shows the SOC range where it
              can draw on the battery; a tactic is <strong>active</strong> when the current SOC
              falls within its range.
            </p>
            <br />
            <p>
              <strong>DR (Demand Response) / VPP</strong>: How much is available for grid facing use
              cases.
            </p>
            <br />
            <p>
              <strong>Time of Use</strong>: How much is available for managing Time Of Use tariffs.
            </p>
            <br />
            <p>
              <strong>DCR Burst</strong>: Battery energy available to offset sudden increases in
              demand.
            </p>
            <br />
            <p>
              <strong>DCR Sustained</strong>: Battery energy available for reducing monthly peak
              demand.
            </p>
          </div>
        </div>
      </div>

      <div className="active-tactics-summary">
        {/* {currentLevel && <span className="active-level-label">{currentLevel.label}</span>} */}
        <span className="active-tactics-list">
          <span className="active-tactics-label">Active Tactics: </span>
          {activeTactics.length > 0 ? (
            activeTactics.map((tactic, i) => (
              <React.Fragment key={tactic.name}>
                {i > 0 && ', '}
                <span className="active-tactic-name">{tactic.name}</span>
              </React.Fragment>
            ))
          ) : (
            <span className="active-tactic-name">No active tactics</span>
          )}
        </span>
      </div>

      <div className="soc-bar-section">
        <span className="bar-row-label soc-bar-label" style={{ gridRow: socRow, gridColumn: 1 }}>
          SOC - {socPercent}%
        </span>
        <div className="soc-bar" style={{ gridRow: socRow, gridColumn: 2 }}>
          <div className="soc-fill" style={{ width: `${socPercent}%` }} />
          <div className="soc-empty" style={{ width: `${100 - socPercent}%` }} />
        </div>

        {activeTactics.map((t, i) => {
          const isActive = socPercent >= t.minSoc && socPercent <= t.maxSoc;
          return (
            <React.Fragment key={t.name}>
              <span
                className={`bar-row-label ${isActive ? 'active' : 'inactive'}`}
                style={{ gridRow: i + 2, gridColumn: 1 }}
              >
                {t.name}
              </span>
              <div className="tactic-bar-track" style={{ gridRow: i + 2, gridColumn: 2 }}>
                <div
                  className={`tactic-bar-fill ${isActive ? 'active' : 'inactive'}`}
                  style={{ left: `${t.minSoc}%`, width: `${t.maxSoc - t.minSoc}%` }}
                />
              </div>
            </React.Fragment>
          );
        })}

        <div
          className="soc-marker"
          style={{ gridRow: `1 / ${markerEndLine}`, gridColumn: 2, marginLeft: `${socPercent}%` }}
        />

        {/*
        <div className="level-bar" style={{ gridRow: levelRow, gridColumn: 2 }}>
          {socLevels.map((l) => (
            <div
              key={l.level}
              className={`level-segment level-${l.level}`}
              style={{ width: `${l.maxSoc - l.minSoc}%` }}
            />
          ))}
        </div>


        <div className="level-indicators" style={{ gridRow: indicatorsRow, gridColumn: 2 }}>
          {socLevels.map((l) => (
            <div
              key={l.level}
              className={`level-indicator ${socPercent >= l.minSoc ? 'active' : 'inactive'}`}
              style={{ width: `${l.maxSoc - l.minSoc}%` }}
            >
              <p className="level-label">{l.label}</p>
              <p className="soc-range-label">
                {l.minSoc}–{l.maxSoc}%
              </p>
            </div>
          ))}
        </div>
        */}
      </div>
    </div>
  );
};

export default BatterySocLevels;
